import * as fromDatatype from '../datatype-library';

export interface bl_wf_mail_handler_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.TextDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  endpoint_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_project_guid: fromDatatype.GuidDataFieldInterface;
  issue_type_guid: fromDatatype.GuidDataFieldInterface;
  default_assignee_guid: fromDatatype.GuidDataFieldInterface;
  default_reporter_guid: fromDatatype.GuidDataFieldInterface;
  code:fromDatatype.TextDatatypeInterface;
  descr:fromDatatype.TextDatatypeInterface;
  notify_user: boolean;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_wf_mail_handler_RowClass
  implements bl_wf_mail_handler_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.TextDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  endpoint_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_project_guid: fromDatatype.GuidDataFieldInterface;
  issue_type_guid: fromDatatype.GuidDataFieldInterface;
  default_assignee_guid: fromDatatype.GuidDataFieldInterface;
  default_reporter_guid: fromDatatype.GuidDataFieldInterface;
  code:fromDatatype.TextDatatypeInterface;
  descr:fromDatatype.TextDatatypeInterface;
  notify_user: boolean;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}
